const PlayTransparentIcon = ({extraClass}: {extraClass?: string}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={13}
      height={16}
      fill="none"
      viewBox="0 0 13 16"
    >
      <path d="M13 8C13.0005 8.20893 12.949 8.41444 12.8507 8.59654C12.7523 8.77864 12.6104 8.93113 12.4386 9.03918L1.79636 15.8189C1.61694 15.9333 1.41144 15.9957 1.20108 15.9998C0.990724 16.0038 0.783143 15.9494 0.599773 15.8419C0.418149 15.7362 0.266852 15.582 0.161439 15.3951C0.0560266 15.2083 0.000303474 14.9956 0 14.7789V1.22109C0.000303474 1.0044 0.0560266 0.791703 0.161439 0.604871C0.266852 0.41804 0.418149 0.263819 0.599773 0.158069C0.783143 0.0506496 0.990724 -0.00384561 1.20108 0.000211026C1.41144 0.00426766 1.61694 0.0667292 1.79636 0.181145L12.4386 6.96082C12.6104 7.06887 12.7523 7.22136 12.8507 7.40346C12.949 7.58556 13.0005 7.79107 13 8Z" fill="currentColor"/>
    </svg>
  )
}

export default PlayTransparentIcon;
